import { Component, Inject, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';

@Component({
  selector: 'app-failedalert',
  templateUrl: './failedalert.component.html',
  styleUrls: ['./failedalert.component.scss']
})
export class FailedalertComponent implements OnInit {

  paramsData: string;
  header: string;

  constructor(
    @Inject(MAT_DIALOG_DATA) public passedData: any,
    private dialogRef: MatDialogRef<FailedalertComponent>
  ) {
    this.paramsData = passedData.alert    ;
    this.header = passedData.header || 'Alert!'; // Default header
  }

  ngOnInit(): void {
    console.log("Header:", this.header);
    console.log("Message:", this.passedData);
  }

  close(event: any) {
    this.dialogRef.close(event);
  }
}
